import {setGetFreespinOperationAction} from '../action';
import { getFreespinOperation } from '../api/getFreespinOperation';

const setGetFreespinOperation = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getFreespinOperation(params);

            if (data.status === 'success') {
                dispatch(setGetFreespinOperationAction({
                    data: data.data,
                    count: data.count,
                    allPage: data.allPage
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetFreespinOperation
}